import { SKIP_REASON_LABELS, type EligibilityActionType, type SkipReason } from '@cdw-ae/common-data';

const EXPORT_LABELS: Partial<Record<EligibilityActionType, Partial<Record<SkipReason, string>>>> = {
  enable: {
    ALREADY_ENABLED: 'Device already enabled or in blocked state',
    STATE_DEPROVISIONED: 'Device already enabled or in blocked state',
    STATE_PRE_PROVISIONED: 'Device already enabled or in blocked state',
  },
  disable: {
    ALREADY_DISABLED: 'Device already disabled or in blocked state',
    STATE_DEPROVISIONED: 'Device already disabled or in blocked state',
    STATE_PRE_PROVISIONED: 'Device already disabled or in blocked state',
  },
  deprovision: {
    ALREADY_DEPROVISIONED: 'Device is already deprovisioned or not yet enrolled',
    STATE_PRE_PROVISIONED: 'Device is already deprovisioned or not yet enrolled',
  },
  'profile-wipe': {
    OS_UPDATE_REQUIRED: 'Needs OS update',
    OS_INCOMPATIBLE: 'Past AUE',
    STATE_DEPROVISIONED: 'Device must be Provisioned for Profile Wipe',
    STATE_PRE_PROVISIONED: 'Device must be Provisioned for Profile Wipe',
  },
  'factory-reset': {
    OS_UPDATE_REQUIRED: 'Needs OS update',
    OS_INCOMPATIBLE: 'Past AUE',
    STATE_DEPROVISIONED: 'Device must be Provisioned for Factory Reset',
    STATE_PRE_PROVISIONED: 'Device must be Provisioned for Factory Reset',
  },
  'move-ou': {
    ALREADY_IN_TARGET_OU: 'Already in target Organizational Unit',
  },
};

export function getExportSkipReasonLabel(actionType: string, reason: string): string {
  const actionLabels = EXPORT_LABELS[actionType as EligibilityActionType];
  if (actionLabels) {
    const label = actionLabels[reason as SkipReason];
    if (label) return label;
  }
  return SKIP_REASON_LABELS[reason as SkipReason] ?? reason;
}
